// extracted by mini-css-extract-plugin
export default {"browser-frame":"cLRlGr","browserFrame":"cLRlGr","browser-frame-content":"u8fz3p","browserFrameContent":"u8fz3p"};